import { useCallback } from 'react';
import { useStoreActions } from '~/contexts.ts';
import { useQueryState } from '~/hooks/reactQuery/useQueryState.tsx';
import { QueryKeys } from '../queryKeys.ts';
export const useRelationship = function useRelationship(relationshipId) {
    let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const { resolvePaymentMethod = true } = options;
    const { api } = useStoreActions();
    const { data: relationship, isLoading, refresh, isBackgroundLoading, optimisticUpdate, error } = useQueryState({
        queryKey: [
            QueryKeys.Relationship,
            relationshipId,
            resolvePaymentMethod
        ],
        queryFn: ()=>api.relationship.get(relationshipId, {
                resolvePaymentMethod
            }),
        refreshOnHookMount: options.refreshOnMount,
        enabled: !!relationshipId
    });
    const refreshRelationship = useCallback(async function() {
        let options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
            silent: false
        };
        const { data } = await refresh(options);
        return data;
    }, [
        refresh
    ]);
    return {
        relationship,
        optimisticUpdate,
        refresh: refreshRelationship,
        isLoading,
        isBackgroundLoading,
        error
    };
};
export const useNonNullableRelationship = function useNonNullableRelationship() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    const data = useRelationship(...args);
    if (!data.relationship) {
        throw new Error('Relationship not found');
    }
    return data;
};
